export const DOCUMENT_REGENERATION_ROLES = new Set([
  "administrator",
  "order-rep",
  "client-rep",
  "purchasing-rep",
  "finance-rep",
]);

export const normalizeDocumentRegenerationRole = (role) =>
  String(role || "")
    .trim()
    .toLowerCase();

export const canInternalUserRegenerateGeneratedDocument = ({
  currentUser = null,
  salesOrder = null,
} = {}) => {
  const normalizedRole = normalizeDocumentRegenerationRole(currentUser?.role);
  const isEligibleInternalUser =
    Boolean(currentUser?.id) &&
    DOCUMENT_REGENERATION_ROLES.has(normalizedRole);

  return (
    isEligibleInternalUser &&
    salesOrder?.canRegenerateDocument === true
  );
};

export const canInternalUserResetSalesOrderApproval = ({
  currentUser = null,
  salesOrder = null,
} = {}) => {
  const baseStatus = String(salesOrder?.status || "").split("_")[0];
  return (
    canInternalUserRegenerateGeneratedDocument({
      currentUser,
      salesOrder,
    }) &&
    baseStatus === "3"
  );
};
